import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Collapse } from "antd";
import { toast } from "react-toastify";

import moment from "moment";

const { Panel } = Collapse;

const RiskAssessmentForm = (props) => {
  const frmRef = useRef({});

  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [farmerId, setFarmerId] = useState();
  const [farmerListData, setFarmerListData] = useState([]);
  const [plotId, setPlotId] = useState();
  const [plotData, setPlotData] = useState([]);
  const [cropId, setCropId] = useState();
  const [varietyData, setVarietyData] = useState([]);
  const [riskHeadData, setRiskHeadData] = useState([]);

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    return uniqueID.toString();
  }

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=Procurement`,
      },
      (data) => {
        //console.log(data);
        var emplist = data.output;

        setEmployeeData(emplist);
      }
    );
  }, []);

  const { sendRequest: getFarmers } = useHttp();

  useEffect(() => {
    getFarmers(
      {
        url: `/api/getfarmerDetail/?fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        //  //console.log(data);
        setFarmerListData(data.output);
      }
    );
  }, [employeeId]);

  const { sendRequest: getPlot } = useHttp();

  useEffect(() => {
    getPlot(
      {
        url: `/api/getfarmerPlotDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerId=${farmerId}`,
      },
      (data) => {
        // //console.log(data);
        setPlotData(data.output);
      }
    );
  }, [farmerId]);

  const { sendRequest: getVariety } = useHttp();

  useEffect(() => {
    getVariety(
      {
        url: `/api/getfarmerCropPlotDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&plotId=${plotId}`,
      },
      (data) => {
        // //console.log(data);
        setVarietyData(data.output);
      }
    );
  }, [plotId]);

  const { sendRequest: getRiskHead } = useHttp();

  const getAllData = () => {
    getRiskHead(
      {
        url: `/api/getRiskHeadField/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        //console.log(res);

        setRiskHeadData(res);
      }
    );
  };

  useEffect(() => {
    getAllData();
  }, []);

  const [uploadedFiles, setUploadedFiles] = useState("");
    const attachmentFolder=localStorage.getItem("attachmentFolder");
  const handleAttachmentChange = (e) => {
    const files = e.target.files;

    const picDataArray = Array.from(files).map((file) => {
      const uniqueFilename = `${new Date().valueOf()}/${file.name}`;
      const picData = new FormData();
      picData.append("fileUpload", file, uniqueFilename);
      return picData;
    });

    const uploadedFilesData = [];

    Promise.all(
      picDataArray.map((picData) =>
        fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/file/${attachmentFolder}/riskAssessmentattachment/${new Date().valueOf()}}`,
          {
            method: "POST",
            body: picData,
          }
        )
          .then((res) => res.json())
          .then((data) => {
            uploadedFilesData.push(data.url);
          })
      )
    )
      .then(() => {
        setUploadedFiles([...uploadedFiles, ...uploadedFilesData]);
      })
      .catch((err) => console.error(err));
  };

  const [uploadedSignature, setUploadedSignature] = useState("");

  const handleSignatureChange = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/riskAssessmentSign/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setUploadedSignature(data.url);
      })
      .catch((err) => console.error(err));
  };

  const handleProbabilityChange = (index, itemIndex, priorityId) => {
    const updatedData = [...riskHeadData];
    updatedData[index].riskHeadList[itemIndex].priorityId = Number(priorityId);

    // Calculate the total and add it to the state
    const severityId =
      updatedData[index].riskHeadList[itemIndex].severityId || 0;
    updatedData[index].riskHeadList[itemIndex].total =
      Number(priorityId) * severityId;

    setRiskHeadData(updatedData);
  };

  const handleSeverityChange = (index, itemIndex, severityId) => {
    // const updatedData = [...riskHeadData];
    // updatedData[index].riskHeadList[itemIndex].severityId = Number(severityId);

    // setRiskHeadData(updatedData);

    const updatedData = [...riskHeadData];
    updatedData[index].riskHeadList[itemIndex].severityId = Number(severityId);

    // Calculate the total and add it to the state
    const priorityId =
      updatedData[index].riskHeadList[itemIndex].priorityId || 0;
    updatedData[index].riskHeadList[itemIndex].total =
      priorityId * Number(severityId);

    setRiskHeadData(updatedData);
  };

  const handleTotalChange = (index, itemIndex, total) => {
    const updatedData = [...riskHeadData];
    updatedData[index].riskHeadList[itemIndex].total = Number(total);

    setRiskHeadData(updatedData);
  };

  const handleRemarkChange = (index, itemIndex, remark) => {
    const updatedData = [...riskHeadData];
    updatedData[index].riskHeadList[itemIndex].remark = remark;

    setRiskHeadData(updatedData);
    //console.log(updatedData);
  };

  const { sendRequest: postRiskAssessment } = useHttp();
  const submitHandler = (e) => {
    e.preventDefault();
    //console.log(riskHeadData);
    const newData = [];

    riskHeadData &&
      riskHeadData.forEach((item) => {
        item.riskHeadList.forEach((riskHead) => {
          const transformedItem = {
            riskAssessmentDetailId: generateUniqueID(),
            priorityId: riskHead.priorityId,
            severityId: riskHead.severityId,
            remark: riskHead.remark,
            riskHeadListId: riskHead.riskHeadListId,
            totalRisk: riskHead.total,
            createdDate: moment(new Date().toISOString()).format(
              "DD/MM/YYYY hh:mm:ss"
            ),
            createdBy: parseInt(localStorage.getItem("id")),
          };

          newData.push(transformedItem);
        });
      });

    //console.log(newData);

    const input = {
      riskAssessment: [
        {
          riskAssessmentId: generateUniqueID(),
          riskAssessmentDate: moment(frmRef.current.date.value).format(
            "DD/MM/YYYY"
          ),
          inspectionType: frmRef.current.inspection_type.value,
          researchOrganization: frmRef.current.research_org.value,
          inspectorName: frmRef.current.inspector_name.value,
          inspectorMobileNo: frmRef.current.mob_no.value,
          inspectorEmailId: frmRef.current.email.value,
          riskAssessmentDetail: newData,
          cropId: cropId,

          inspectStatus: frmRef.current.inspect_status.value,
          riskStatus: frmRef.current.risk_status.value,
          fileAttachment: uploadedFiles,
          signatureAttachment: uploadedSignature,
          createdDate: moment(new Date().toISOString()).format(
            "DD/MM/YYYY hh:mm:ss"
          ),
        },
      ],

      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
    };

    //console.log(input);

    const newData2 = [];
    riskHeadData &&
      riskHeadData.forEach((item) => {
        item.riskHeadList.forEach((riskHead) => {
          const transformedItem = {
            riskAssessmentDetailId: riskHead.riskAssessmentDetailId,
            priorityId: riskHead.priorityId,
            severityId: riskHead.severityId,
            remark: riskHead.remark,
            riskHeadListId: riskHead.riskHeadListId,
            totalRisk: riskHead.total,
            createdDate: moment(new Date().toISOString()).format(
              "DD/MM/YYYY hh:mm:ss"
            ),
            createdBy: parseInt(localStorage.getItem("id")),
          };

          newData2.push(transformedItem);
        });
      });

    const input2 = {
      riskAssessment: {
        riskAssessmentId: props.update.riskAssessmentId,
        riskAssessmentDate: moment(frmRef.current.date.value).format(
          "DD/MM/YYYY"
        ),
        inspectionType: frmRef.current.inspection_type.value,
        researchOrganization: frmRef.current.research_org.value,
        inspectorName: frmRef.current.inspector_name.value,
        inspectorMobileNo: frmRef.current.mob_no.value,
        inspectorEmailId: frmRef.current.email.value,
        riskAssessmentDetail: newData2,
        cropId: cropId,

        inspectStatus: frmRef.current.inspect_status.value,
        riskStatus: frmRef.current.risk_status.value,
        fileAttachment: uploadedFiles,
        signatureAttachment: uploadedSignature,
        createdDate: moment(new Date().toISOString()).format(
          "DD/MM/YYYY hh:mm:ss"
        ),
        createdBy: parseInt(localStorage.getItem("id")),
      },
      createdDate: moment(new Date().toISOString()).format(
        "DD/MM/YYYY hh:mm:ss"
      ),
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
    };

    postRiskAssessment(
      {
        url: "/api/riskAssessment/",
        method: props.update ? "PUT" : "POST",
        body: props.update ? input2 : input,
      },
      (data) => {
        // //console.log(data);

        toast.success(
          `Risk Assessment Data ${
            props.update ? "Updated" : "Added Successfully"
          }`
        );
        props.addForm(false);
      }
    );
  };

  const { sendRequest: getRiskAss } = useHttp();

  useEffect(() => {
    if (props.update) {
      //console.log(props.update);
      const Id = props.update.riskAssessmentId || 0;
      //console.log(props.update.riskAssessmentDate);

      const parts =
        props.update.riskAssessmentDate &&
        props.update.riskAssessmentDate.split("/");
      if (parts && parts.length === 3) {
        const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        setSelectedDate(formattedDate);
      }

      getRiskAss(
        {
          url: `/api/riskAssessment/?orgId=${localStorage.getItem(
            "orgId"
          )}&riskAssessmentId=${Id}&editData=edit `,
        },
        (data) => {
          //console.log(data);

          setEmployeeId(data && data.riskAssessment.fieldExecutiveId);
          setFarmerId(data && data.riskAssessment.farmerId);
          setPlotId(data && data.riskAssessment.farmerPlotId);
          setCropId(data && data.riskAssessment.cropId);
          frmRef.current.inspector_name.value =
            data.riskAssessment && data.riskAssessment.inspectorName;
          frmRef.current.mob_no.value =
            data.riskAssessment && data.riskAssessment.inspectorMobileNo;
          frmRef.current.email.value =
            data.riskAssessment && data.riskAssessment.inspectorEmailId;
          frmRef.current.research_org.value =
            data.riskAssessment && data.riskAssessment.researchOrganization;

          frmRef.current.inspect_status.value =
            data.riskAssessment && data.riskAssessment.inspectStatus;
          frmRef.current.risk_status.value =
            data.riskAssessment && data.riskAssessment.riskStatus;

          frmRef.current.inspection_type.value =
            data.riskAssessment && data.riskAssessment.inspectionType;

          setUploadedFiles(
            data.riskAssessment && data.riskAssessment.fileAttachment
          );
          setUploadedSignature(
            data.riskAssessment && data.riskAssessment.signatureAttachment
          );

          setRiskHeadData(
            data.riskAssessment && data.riskAssessment.riskHeadFieldList
          );
        }
      );
    }
  }, [props.update]);
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Sales Order Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"executive_name"}>
                        {"Field Executive"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option key={x.userId} value={x.userId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"farmer_name"}>{"Farmer Name"}</label>
                      <select
                        id="farmerId"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["farmer_name"] = el)}
                        value={farmerId}
                        required
                        onChange={(e) => {
                          setFarmerId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {farmerListData &&
                          farmerListData.map((x) => (
                            <option key={x.farmerId} value={x.farmerId}>
                              {x.farmerName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"plot_name"}>{"Plot Name"}</label>

                      <select
                        id="plot_name"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["plot_name"] = el)}
                        required
                        value={plotId}
                        onChange={(e) => {
                          setPlotId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {plotData &&
                          plotData.map((x) => (
                            <option key={x.plotId} value={x.plotId}>
                              {x.plotName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"crop_variety"}>{"Crop Variety"}</label>
                      <select
                        id="crop_variety"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["crop_variety"] = el)}
                        value={cropId}
                        required
                        onChange={(e) => {
                          setCropId(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {varietyData &&
                          varietyData.map((x) => (
                            <option key={x.cropId} value={x.cropId}>
                              {x.cropVariety}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspection_type"}>
                        {"Inspcection Type"}
                      </label>
                      <select
                        id="inspection_type"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["inspection_type"] = el)}
                        required
                      >
                        <option value="">Select</option>

                        <option value="Self-assessment">Self-assessment</option>
                        <option value="Chosen certification body">
                          Chosen certification body
                        </option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"research_org"}>
                        {"Research Organization"}
                      </label>
                      <input
                        type={"text"}
                        id={"research_org"}
                        required
                        ref={(el) => (frmRef.current["research_org"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspector_name"}>
                        {"Inspector Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"inspector_name"}
                        required
                        ref={(el) => (frmRef.current["inspector_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"mob_no"}>{"Inspector Mobile No"}</label>
                      <input
                        type={"text"}
                        id={"mob_no"}
                        required
                        ref={(el) => (frmRef.current["mob_no"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"mob_no"}>{"Inspector EmailId"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <br />
                  <div className="">
                    {riskHeadData &&
                      riskHeadData.map((x, index) => (
                        <>
                          <Collapse>
                            <Panel
                              header={x.riskHeadName}
                              key={index + 1}
                              // className={isGreen(index) ? "panel-green" : "panel-orange"}
                            >
                              {x.riskHeadList &&
                                x.riskHeadList.map((item, itemIndex) => (
                                  <>
                                    <b htmlFor={index}>{item.riskFieldName}</b>
                                    <br />
                                    <div className="row mb-2">
                                      <div className="col-md-3">
                                        <label htmlFor={itemIndex}>
                                          Probability:
                                        </label>
                                        <select
                                          className="form-control"
                                          value={item.priorityId || ""}
                                          onChange={(e) =>
                                            handleProbabilityChange(
                                              index,
                                              itemIndex,
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">
                                            Select an option
                                          </option>
                                          <option value="5">Frequent</option>
                                          <option value="4">Probable</option>
                                          <option value="3">Occasional</option>
                                          <option value="2">Remote</option>
                                          <option value="1">Improbable</option>
                                        </select>
                                      </div>
                                      <div className="col-md-3">
                                        <label htmlFor={`dropdown-${index}`}>
                                          Severity:
                                        </label>
                                        <select
                                          className="form-control"
                                          value={item.severityId || ""}
                                          onChange={(e) =>
                                            handleSeverityChange(
                                              index,
                                              itemIndex,
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">
                                            Select an option
                                          </option>
                                          <option value="4">
                                            Catastrophic
                                          </option>
                                          <option value="3">Critical</option>
                                          <option value="2">Marginal</option>
                                          <option value="1">Negligible</option>
                                        </select>
                                      </div>
                                      <div className="col-md-3">
                                        <label>Total: </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={
                                            item.total !== undefined
                                              ? item.total
                                              : item.priorityId *
                                                item.severityId
                                          }
                                          onChange={(e) =>
                                            handleTotalChange(
                                              index,
                                              itemIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <div className="col-md-3">
                                        <label> Remark: </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={item.remark || ""}
                                          onChange={(e) =>
                                            handleRemarkChange(
                                              index,
                                              itemIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </div>
                                      <br />
                                    </div>
                                    <br />
                                  </>
                                ))}
                            </Panel>
                          </Collapse>
                          <br />
                        </>
                      ))}
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor={"risk_status"}>{"Risk Status"}</label>
                      <select
                        id="inspect_status"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["risk_status"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        <option value="true">Pass</option>
                        <option value="false">Fail</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspect_status"}>
                        {"Inspect Status"}
                      </label>
                      <select
                        id="inspect_status"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["inspect_status"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        <option value="true">Approved</option>
                        <option value="false">Denied</option>
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"Attachment"}>{"Attachment"}</label>
                      <label className="custom-file-upload">
                        <input
                          type="file"
                          id={"attachment"}
                          ref={(el) => (frmRef.current["attachment"] = el)}
                          className="form-control"
                          multiple
                          onChange={handleAttachmentChange}
                        />
                      </label>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Signature"}>{"Signature"}</label>
                      <label className="custom-file-upload">
                        <input
                          type="file"
                          id={"signature"}
                          ref={(el) => (frmRef.current["signature"] = el)}
                          className="form-control"
                          onChange={handleSignatureChange}
                        />
                      </label>
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RiskAssessmentForm;
